import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { Card } from 'antd';
import './mainpage.css';

import iconHistory from '../static/main-icon1.png';
import iconJob from '../static/main-icon2.png';
import iconFAQ from '../static/main-icon3.png';
import iconViewMore from '../static/viewmore.png';

import MainTopNav from "./MainTopNav";
import MainFooter from "./MainFooter";
import Translate from "../translate/Translate";

import {
  mainpageUpdateTrad,
  mainpageUpdateSimp,
  mainpageUpdateEng,
  addRecord
} from '../../modules/mainpage';

class Mainpage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLang: 2,
      language: [["en", "EN", "inline"], ["sc", "简", "inline"], ["tc", "繁", "none"]],
    }
  }

  componentDidMount() {
    if (!this.props.language) {
      this.props.mainpageUpdateTrad();
      console.log(this.props.language)
    }
    this.props.addRecord();
  }

  changeLanguage = (id) => {
    switch (id) {
      case 0: this.props.mainpageUpdateEng();
      case 1: this.props.mainpageUpdateSimp();
      case 2: this.props.mainpageUpdateTrad();
      default: this.props.mainpageUpdateTrad();
    }

    this.setState(state => {
      const currentLang = id;
      const language = state.language.map((item, j) => {
        if (j === id) {
          item[2] = "none";
          return item;
        } else {
          item[2] = "inline";
          return item;
        }
      });

      return {
        currentLang, language,
      };
    });
  }

  startTest = () => {
    localStorage.clear()
    this.props.history.push('/login');
  }


  render() {

    return (
      <div>

        <div className="banner">
          {/* ---------------Header top bar--------------- */}
          <MainTopNav />
          {/* ---------------Header banner--------------- */}
          <div className="bannerContainer">
            <div className="space"></div>
            <div className="titleContainer">
              <div className="title">
                SDS <br></br>
                <Translate id="main.title" />
              </div>
              <div className="intro">
                <Translate id="main.intro" />
              </div>
              <div className="startBtn">
                <Button type="primary" shape="round" size="large" onClick={this.startTest}>
                  <Translate id="main.start" />
                </Button>
              </div>
              <div className="viewMore">
                <Translate id="main.viewmore" />
                <p ><img src={iconViewMore} className="viewMoreIcon"></img></p>
              </div>
            </div>
            <div className="space"></div>
          </div>
        </div>
        {/* ---------------Content--------------- */}
        <div className="contentContainer">
          <div className="navigateContainer">
            <div className="navigatorTitle">
              <Translate id="main.subtitle" />
            </div>
            <div className="navigatorBtn">
              <Card hoverable onClick={() => this.props.history.push("./history")}>
                <p ><img src={iconHistory} className="cardIcon"></img></p>
                <div className="cardTitle"><Translate id="main.history.title" /></div>
                <div className="cardIntro"><Translate id="main.history.intro" /></div>
              </Card>
              <Card hoverable onClick={() => this.props.history.push("./searchJob")}>
                <p ><img src={iconJob} className="cardIcon"></img></p>
                <div className="cardTitle"><Translate id="main.job.title" /></div>
                <div className="cardIntro"><Translate id="main.job.intro" /></div>
              </Card>
              <Card>
                <p ><img src={iconFAQ} className="cardIcon"></img></p>
                <div className="cardTitle"><Translate id="main.qa.title" /></div>
                <div className="cardIntro"><Translate id="main.qa.intro" /></div>
              </Card>
            </div>
          </div>
          {/* ---------------Contact--------------- */}
          <div className="contactContainer">
            <div className="contactInfo">
              <p className="contactTitle"><Translate id="main.contact" /></p>
              <p className="contactDetail">
                <Translate id="main.address" /><br></br>
                <Translate id="main.tel" /><br></br>
                <Translate id="main.whatsapp" /><br></br>
              </p>
            </div>
            <div className="contactMap">
              <iframe width="100%" height="300" id="gmap_canvas" src="https://maps.google.com/maps?q=%20%E6%96%B0%E7%95%8C%E5%B0%87%E8%BB%8D%E6%BE%B3%E5%94%90%E6%98%8E%E8%8B%91%E5%81%9C%E8%BB%8A%E5%A0%B4%E5%A4%A7%E6%A8%93%E5%9C%B0%E4%B8%8B&t=&z=19&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0">
              </iframe>
              <a href="https://yt2.org/youtube-to-mp3-ALeKk00qEW0sxByTDSpzaRvl8WxdMAeMytQ1611842368056QMMlSYKLwAsWUsAfLipqwCA2ahUKEwiikKDe5L7uAhVFCuwKHUuFBoYQ8tMDegUAQCSAQCYAQCqAQdnd3Mtd2l6"></a>
            </div>
          </div>
        </div>
        {/* ---------------Footer--------------- */}
        <MainFooter />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      mainpageUpdateTrad,
      mainpageUpdateSimp,
      mainpageUpdateEng,
      addRecord
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Mainpage);